import React from "react";
import { Pie } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend, TooltipItem } from "chart.js";

ChartJS.register(ArcElement, Tooltip, Legend);

interface PieChartData {
  datasets: {
    data: number[];
    backgroundColor: string[];
    text: string[];
   labels: string;
  borderColor: string[];
  hoverOffset: number;
  }[];
}

interface CircleChartProps {
  setCurent: (dataIndex: number) => void;
  className: string;
  piData: PieChartData;
}

const splitText = (str: string, maxLen: number) => {
  const result: string[] = [];
  let currentLine = "";

  str.split(" ").forEach((word) => {
    if ((currentLine + word).length <= maxLen) {
      currentLine += (currentLine ? " " : "") + word;
    } else {
      if (currentLine) result.push(currentLine);
      currentLine = word;
    }
  });

  if (currentLine) result.push(currentLine);
  return result;
};

const CircleChart: React.FC<CircleChartProps> = ({ setCurent, className, piData }) => {
  console.log("🚀 ~ setCurent, className, piData:", setCurent, className, piData)

  const transformedData = piData.datasets[0].data.map((value) => Number(value));
  console.log("🚀 ~ transformedData:", transformedData)

  const options = {
    maintainAspectRatio: false,
    responsive: true,
    height: "auto",
    width: 273,
    plugins: {
      tooltip: {
        backgroundColor: "rgba(0, 0, 0, 0.7)",
        borderColor: "transparent",
        titleColor: "#fff",
        bodyColor: "#fff",
        displayColors: false,
        callbacks: {
          label: function (context: TooltipItem<'pie'>) {
            const dataIndex = context.dataIndex;
            setCurent(dataIndex);
            const currentValue = context.parsed;
            const text = piData.datasets[0].text[dataIndex] + ` ${currentValue}%`;
            return splitText(text, 30);
          },
        },
      },
    },
  };

  return (
    <div className={className}>
      <Pie data={{ datasets: [{ ...piData.datasets[0], data: transformedData }] }} options={options} />
    </div>
  );
};

export default CircleChart;
